define('home/views/ChannelsModuleView',[
    'backbone-marionette',

    'home/views/FetchingView',
    'home/views/ChannelsModuleItemView',

    'home/templates/channelsModule',
], function (
    Marionette,

    FetchingView,
    ChannelsModuleItemView,

    channelsModuleTemplate
) {
    'use strict';

    /**
     * Shows a randomized subset of given channels listed in a module view.
     * Expects a Collection of ChannelProfiles or Channels
     */
    var ChannelsModuleView = Marionette.CompositeView.extend({
        template: channelsModuleTemplate,

        itemView: ChannelsModuleItemView,
        itemViewContainer: '[data-role=channels]',
        itemViewOptions: function (item) {
            return {
                model: item.channel || item,
            };
        },

        addItemView: function (item, ItemView, index) {
            if (index > this.constructor.CHANNELS_MAX - 1)
                return;

            return Marionette.CompositeView.prototype.addItemView.call(this, item, ItemView, index);
        },

        emptyView: function () {
            return new FetchingView({
                className: 'spinner-small',
            });
        },
    }, {
        CHANNELS_MAX: 3,
    });

    return ChannelsModuleView;
});

